export default "__VITE_ASSET__BM0zPdrp__"